export default __webpack_public_path__ + "static/media/093-chevron-1.c5edd3d8.png";